import React from 'react'
import {
  If,
  Loader,
} from '@paytrace/pt-skel/Component'
import { InfoIcon } from '@paytrace/pt-skel/Component/Icon'
import { TransactionHistorySearch as TransactionHistorySearchReq } from '@paytrace/pt-sdk'
import { useTransactionSearch } from '../hooks/useTransactionSearch'
import ViewTransactionResult, {
  hasNoSearchResults,
  hasSearchError,
  isSearchingState,
  isSuccessSearchState,
  NoResultsFound,
} from '../Component/ViewTransactionResult'
import { TransactionHistorySearchForm } from '../Component/ViewTransactionForm'
import './ViewTransactions.css'

const self = Symbol('ViewTransactions')

export function ViewTransactions () {
  const {
    doSearch, searchResponse, status, activeSearchCriteria, setActiveSearchCriteria,
  } = useTransactionSearch(self)

  const submit = (data: TransactionHistorySearchReq) => {
    setActiveSearchCriteria(data)
    doSearch(data)
  }

  return <>
    <div className="float-right">
      <a target="_blank" rel="noreferrer" className="btn btn-small btn-info uid-help-info-link" href="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2027258392/View+Transactions">
        Help <InfoIcon />
      </a>
    </div>
    <h1>View Transactions</h1>
    <hr className="clear" />

    <TransactionHistorySearchForm onSubmit={submit} />

    <If is={isSearchingState(status, searchResponse)}>
      <Loader />
    </If>

    <If is={hasNoSearchResults(status, searchResponse)}>
      <NoResultsFound />
    </If>

    <If is={hasSearchError(status, searchResponse)}>
      <div className="no-results-found">An error occurred during search.</div>
    </If>

    <If is={isSuccessSearchState(status, searchResponse) && !hasNoSearchResults(status, searchResponse)}>
      <ViewTransactionResult
        summary={searchResponse?.summary}
        cardSummaries={searchResponse?.cardSummaries}
        transactions={searchResponse?.transactions}
        searchStatus={status}
        searchCriteria={activeSearchCriteria}
        // show the results with or without buttons and overflow
        showAll={false}
      />
    </If>
  </>
}

export default ViewTransactions
